import { SvgIcon, SvgIconProps } from "@mui/material"

/**
 * Ícone de critérios de priorização: lista numerada (1, 2, 3) com seta para cima,
 * sugerindo ordenação por prioridade. Usa currentColor para herdar a cor do tema.
 */
const PriorityListIcon = (props: SvgIconProps) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        {/* números 1, 2, 3 */}
        <text x="0.5" y="8.4" fontSize="6.5" fontWeight="700" fill="currentColor">1</text>
        <text x="0.5" y="14.9" fontSize="6.5" fontWeight="700" fill="currentColor">2</text>
        <text x="0.5" y="21.4" fontSize="6.5" fontWeight="700" fill="currentColor">3</text>
        {/* linhas da lista */}
        <rect x="6.5" y="5.4" width="9.5" height="1.7" rx="0.85" fill="currentColor" />
        <rect x="6.5" y="11.9" width="9.5" height="1.7" rx="0.85" fill="currentColor" />
        <rect x="6.5" y="18.4" width="9.5" height="1.7" rx="0.85" fill="currentColor" />
        {/* seta para cima */}
        <path
            d="M20.4 20.5 V7.2 M20.4 6 L17.9 9 M20.4 6 L22.9 9"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
    </SvgIcon>
)

export { PriorityListIcon }
